import { cryptoRandomUUID } from '@finxone-platform/shared/sys-config-types';

const labelTextSkeleton = (widthClass: string) => `
<span class="labelText skeleton_item ${widthClass}">
  <span class="skeleton_item"></span>
</span>
`;

export const selectedNotificationSkeleton = {
  id: cryptoRandomUUID().toString(),
  destinationIdentifier: {
    id: cryptoRandomUUID().toString(),
    currency: labelTextSkeleton('skeleton_25'),
    accountNumber: labelTextSkeleton('skeleton_75'),
    sortCode: labelTextSkeleton('skeleton_50'),
  },
  address: {
    id: cryptoRandomUUID().toString(),
    country: labelTextSkeleton('skeleton_100'),
  },
  name: labelTextSkeleton('skeleton_100'),
  createdDate: labelTextSkeleton('skeleton_50'),
  updatedDate: labelTextSkeleton('skeleton_50'),
  deletedDate: labelTextSkeleton('skeleton_50'),
};
